import React, { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import classnames from "classnames";
import { BasicDetailsTypes, IChatUserDetails } from "../../../types/profile";

interface AttachedFilesProps {
  chatUserDetails: IChatUserDetails;
  isFavourite: boolean,
  isMarked: boolean,
  isSession: boolean,
  onOpenVideo: () => void;
  onOpenAudio: () => void;
  onToggleMessageClose: () => void;
  onToggleFavourite: () => void;
  onToggleArchive: () => void;
  onToggleMarked: () => void;
  onOpenVisit: (data: any) => void;
  onOpenService: (data: any) => void;
}
const AttachedFiles = ({
  chatUserDetails,
  isFavourite,
  isMarked,
  isSession,
  onOpenVideo,
  onOpenAudio,
  onToggleMessageClose,
  onToggleFavourite,
  onToggleArchive,
  onToggleMarked,
  onOpenService,
  onOpenVisit,
}: AttachedFilesProps) => {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  // console.log('chatUserDetails', chatUserDetails)

  const isVisit = !!chatUserDetails.basicDetails.dataVisita;
  // const isService = chatUserDetails.basicDetails.ativo == 1 ? true : false;
  const isService = chatUserDetails.basicDetails.marked == 1 ? true : false;
  // console.log('isService', isService)

  const handleFinishSession = async () => {
    if (!isSession) return;
    onToggleMessageClose();
  };

  return (
    <div className="text-center border-bottom">
      <div className="row">

        <div className="col-sm col-2">
          <div className="mb-4">
            <Button color="none"
              type="button"
              className="btn avatar-sm p-0"
              // disabled={!isSession}   // só habilita se tem sessão ativa 
              onClick={handleFinishSession}>

              <span className="avatar-title rounded bg-light text-body">
                <i
                  className={`bx ${isSession ? "bx bx-lock-open text-danger" : "bx bx-lock text-muted"
                    }`}
                />
              </span>

              {/* <span className="avatar-title rounded bg-light text-body">
                {isSession ? <i className="bx bx-lock-open"></i> :
                  <i className="bx bx-lock"></i>
                }
              </span> */}
            </Button>
            <h5 className="font-size-11 text-uppercase text-muted mt-2">
              {isSession ? "Encerrar" : "Finalizada"}
            </h5>
          </div>
        </div>

        <div className="col-sm col-2">
          <div className="mb-4">
            <Button
              color="none"

              className={classnames(
                "btn",
                "avatar-sm",
                "p-0",
                "favourite-btn",
                { active: isFavourite }
              )}
              onClick={onToggleFavourite}
            >
              <span className="avatar-title rounded bg-light text-body">
                <i className="bx bx-heart"></i>
              </span>
            </Button>
            <h5 className="font-size-11 text-uppercase text-muted mt-2">
              Favoritar
            </h5>
          </div>
        </div>

        <div className="col-sm col-2">
          <div className="mb-4">
            <Button
              color="none"
              className="btn avatar-sm p-0"
              onClick={onOpenVisit}
            >
              <span className="avatar-title rounded bg-light text-body">
                <i
                  className={`bx ${isVisit ? "bxs-calendar-check text-primary" : "bx-calendar text-muted"
                    }`}
                />
              </span>
            </Button>
            <h5 className="font-size-11 text-uppercase text-muted mt-2">
              Agendar
            </h5>
          </div>
        </div>

        <div className="col-sm col-2">
          <div className="mb-4">
            <Button
              color="none"
              className="btn avatar-sm p-0"
              onClick={onToggleMarked}
            >
              <span className="avatar-title rounded bg-light text-body">
                <i
                  className={`bx ${isMarked ? "bxs-purchase-tag-alt text-primary" : " bxs-purchase-tag-alt text-muted"
                    }`}
                />
              </span>
            </Button>
            <h5 className="font-size-11 text-uppercase text-muted mt-2">
              Marcar
            </h5>
          </div>
        </div>

        <div className="col-sm col-2">
          <div className="mb-4">
            <Button
              color="none"
              className="btn avatar-sm p-0"
              onClick={onOpenService}
            >
              <span className="avatar-title rounded bg-light text-body">
                <i
                  className={`bx bxs-like ${isService ? "text-primary" : "text-muted"
                    }`}
                />
              </span>
            </Button>
            <h5 className="font-size-11 text-uppercase text-muted mt-2">
              Atender
            </h5>
          </div>
        </div>

        {/* Audio */}
        {/* <div className="col-sm col-4">
          <div className="mb-4">
            <Button
              color="none"
              className="btn avatar-sm p-0"
              onClick={onOpenAudio}
            >
              <span className="avatar-title rounded bg-light text-body">
                <i className="bx bxs-phone-call"></i>
              </span>
            </Button>
            <h5 className="font-size-11 text-uppercase text-muted mt-2">
              Audio
            </h5>
          </div>
        </div> */}

        {/* video */}
        {/* <div className="col-sm col-4">
          <div className="mb-4">
            <Button
              color="none"
              type="button"
              className="btn avatar-sm p-0"
              onClick={onOpenVideo}
            >
              <span className="avatar-title rounded bg-light text-body">
                <i className="bx bx-video"></i>
              </span>
            </Button>
            <h5 className="font-size-11 text-uppercase text-muted mt-2">
              Vidêo
            </h5>
          </div>
        </div> */}

        {/* <div className="col-sm col-4">
          <div className="mb-4">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle
                color="none"
                className="btn avatar-sm p-0 dropdown-toggle"
                type="button"
              >
                <span className="avatar-title bg-light text-body rounded">
                  <i className="bx bx-dots-horizontal-rounded"></i>
                </span>
              </DropdownToggle> */}

        {/* <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  className=" d-flex justify-content-between align-items-center"
                  to="#"
                  onClick={onToggleArchive}
                >
                  {chatUserDetails.isArchived ? (
                    <>
                      Desarquivar{" "}
                      <i className="bx bx-archive-out text-muted"></i>
                    </>
                  ) : (
                    <>
                      Arquivar <i className="bx bx-archive text-muted"></i>
                    </>
                  )}
                </DropdownItem>
                <DropdownItem
                  className=" d-flex justify-content-between align-items-center"
                  to="#"
                >
                  Silenciar <i className="bx bx-microphone-off text-muted"></i>
                </DropdownItem>
                <DropdownItem
                  className=" d-flex justify-content-between align-items-center"
                  to="#"
                >
                  Excluir <i className="bx bx-trash text-muted"></i>
                </DropdownItem>
              </DropdownMenu> */}
        {/* </Dropdown>
            <h5 className="font-size-11 text-uppercase text-muted mt-2">
              Mais
            </h5>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AttachedFiles;
